import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
} from '@angular/core';
import { ProductComponent } from '../../product/product.component';
import { NgFor } from '@angular/common';
import { Product } from '../../cart.model';
import { CartService } from '../../cart.service';

import { TabViewModule } from 'primeng/tabview';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { ProductService } from '@src/app/dashboard/restaurant/product/product/product.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [
    NgFor,
    ProductComponent,
    TabViewModule,
    BadgeModule,
    AvatarModule,
    ButtonModule,
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
})
export class ProductListComponent implements OnInit {
  cartService = inject(CartService);
  productService = inject(ProductService);
  items!: Product[];
  pizzas!: Product[];
  salads!: Product[];
  drinks!: Product[];
  wine_cellar!: Product[];
  desserts!: Product[];
  combos!: Product[];

  private stickyTabView!: HTMLElement;
  private stickyOffsetTop: number = 0;

  constructor(private el: ElementRef) {
    this.getProductList();
  }

  ngOnInit() {
    // Obtén el elemento del TabView
    this.stickyTabView = this.el.nativeElement.querySelector('.stickyTabView');
    if (this.stickyTabView) {
      this.stickyOffsetTop = this.stickyTabView.offsetTop;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.stickyTabView) {
      const tabViewBottom =
        this.stickyTabView.offsetTop + this.stickyTabView.offsetHeight;

      if (
        scrollPosition > this.stickyOffsetTop &&
        scrollPosition < tabViewBottom
      ) {
        this.stickyTabView.classList.add('is-sticky');
      } else {
        this.stickyTabView.classList.remove('is-sticky');
      }
    }
  }

  async getProductList() {
    this.productService.getList().subscribe(async (response: any) => {
      const activeElements = await response.filter(
        (element: Product) => element.is_active == 1
      );

      this.pizzas = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 1
      );

      this.salads = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 2
      );

      this.drinks = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 3
      );

      this.wine_cellar = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 4
      );

      this.desserts = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 5
      );

      this.combos = await activeElements.filter(
        (element: Product) => element.restaurant_product_type_id == 6
      );
    });
  }

  onTabChange() {
    const tabViewHeader = this.el.nativeElement.querySelector(
      '.p-tabview-nav-content'
    );

    if (tabViewHeader) {
      // Calcula la posición del encabezado en la página
      // const headerPosition =
      //   tabViewHeader.getBoundingClientRect().top +
      //   window.scrollY -
      //   tabViewHeader.offsetHeight;

      window.scrollTo({
        top: this.stickyOffsetTop - 30,
        behavior: 'smooth',
      });
    }
  }
}
